export const MERCHANT_INFO = {
  legalName: "OD INFORMACIONE DJELATNOSTI",
  address: "Ul. Prvomajska br. 25, 71000 Sarajevo, Bosna i Hercegovina",

  // TODO: Replace with the exact registered values before deploying.
  businessActivity: "Informacione djelatnosti",
  activityCode: "62.09",
  registrationNumber: "4304145350003",

  taxNumber: "4304145350003",
  website: "https://rentpilot.solutions",
  phone: "+387 60 3045 425",
  email: "info@rentpilot.solutions",

  customerService: {
    address: "Ul. Prvomajska br. 25, 71000 Sarajevo, Bosna i Hercegovina",
    phone: "+387 60 3045 425",
    email: "info@rentpilot.solutions",
  },
} as const;
